export default "__VITE_ASSET__623fe960__"